var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.5 36.65V18a1 1 0 0 0-.5-.87l-24.25-14a1 1 0 0 0-1 0l-24.25 14A1 1 0 0 0 3 18v28a1 1 0 0 0 .5.87l24.25 14a1 1 0 0 0 1 0l9.11-5.26a12.74 12.74 0 1 0 15.64-19zM28.25 5.15 50.5 18l-11.16 6.44-20.66-13.76zm0 25.7L6 18l10.75-6.21L37.4 25.56zm7.25 17.4a12.69 12.69 0 0 0 1.33 5.64l-7.58 4.38V32.58l9-5.23v7.79a1 1 0 0 0 2 0V26.2l11.2-6.47v16.21a12.44 12.44 0 0 0-3.25-.44 12.76 12.76 0 0 0-12.7 12.75zm19-4-6.9 9.19a1 1 0 0 1-.77.4 1 1 0 0 1-.76-.35L42 48.71a1 1 0 0 1 1.53-1.29l3.25 3.82L53 43.06a1 1 0 1 1 1.59 1.21z",
    "data-name": "Layer 32",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedorder);
export default __webpack_public_path__ + "static/media/completed order.011594a88c5fc0fa26070ada3cee5e87.svg";
export { ForwardRef as ReactComponent };